import styled from 'styled-components';
import Banner from 'components/banner/Banner';

import MembershipManagement from 'components/mypage/MembershipManagement';
import AccountInfo from 'components/mypage/AccountInfo';
// import LoginManagement from 'components/mypage/LoginManagement';
// import AccountLink from 'components/mypage/AccountLink';
import { Tabs } from 'antd';
import companyInforAtom from 'atom/companyInfoAtom';
import userInforAtom from 'atom/userInfoAtom';
import { useAtomValue } from 'jotai';
import Sales from './Sales';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const MyPage = () => {
  const userInfo = useAtomValue(userInforAtom);
  const companyInfo = useAtomValue(companyInforAtom);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const activeTabKeyFromParam = urlParams.get('tab');

  const [activeTabKey, setActiveTabKey] = useState(activeTabKeyFromParam || '1');

  const b2cData = [
    {
      key: '1',
      label: '멤버십관리',
      children: <MembershipManagement />
    },
    {
      key: '2',
      label: '매출관리',
      children: <Sales companyInfo={companyInfo} />
    },
    {
      key: '3',
      label: '계정정보',
      children: <AccountInfo userInfo={userInfo} companyInfo={companyInfo} />
    }
  ];

  const b2bData = [
    {
      key: '1',
      label: '멤버십관리',
      children: <MembershipManagement />
    },
    {
      key: '2',
      label: '계정정보',
      children: <AccountInfo userInfo={userInfo} companyInfo={companyInfo} />
    }
  ];

  const datas = companyInfo.salestypeidx === 1 ? b2bData : b2cData;

  useEffect(() => {
    const newUrl = `${window.location.pathname}?tab=${activeTabKey}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }, [activeTabKey]);

  return (
    <Wrapper>
      <section>
        <Banner companyInfo={companyInfo} userInfo={userInfo} />
      </section>
      <ContentsWrapper>
        <Tabs
          activeKey={activeTabKey}
          items={datas}
          onChange={(activeTabKey) => {
            setActiveTabKey(activeTabKey);
          }}
        />
      </ContentsWrapper>
    </Wrapper>
  );
};

export default MyPage;

const Wrapper = styled.div`
  max-width: 1440px;
  padding: 0 48px;
  margin: 0 auto;

  .ant-tabs .ant-tabs-tab {
    padding: 0 0 12px 0;
  }

  .ant-tabs .ant-tabs-tab-btn {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  section {
    padding-top: 24px;
  }
`;

const ContentsWrapper = styled.div`
  margin: 48px 0;

  .ant-tabs .ant-tabs-nav {
    margin-bottom: 48px;
  }
`;
